import styled from "styled-components";

const FormError = styled.div`
    * {
        color: ${props => props.theme.red};
        font-size: 1.3rem;
        margin: 0;
    }
    margin-bottom: 2rem;
`;

export default FormError;
